import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FilterWithMapper from '../FilterWithMapper/FilterWithMapper';
import { currency, currencyMapper } from '@nexio/emvio-util-app';
import * as localStorageUtil from '../../../../utils/localStorageUtil';

const currencyHistoryKey = 'currencyHistory';
const defaultCurrencyHistory = [ currency.usd.id ];

export class SmartCurrencyCodeFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            currencyList: []
        };

        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.updateCurrencyList();
    }

    updateCurrencyList(currencyHistory) {
        if (!currencyHistory || _.isEmpty(currencyHistory)) {
            currencyHistory = localStorageUtil.getItem(currencyHistoryKey) || defaultCurrencyHistory;
        }
        let currencyList = _.mapValues(currencyMapper, (currencyObj) => {
            return `${currencyObj.code} - (${currencyObj.symbol})`;
        });

        const newCurrencyList = _.map(currencyHistory, (currencyId) => {
            const currency = currencyList[currencyId];

            return [ currencyId, currency, `${currencyId}-history` ];
        });

        currencyList = _.toPairs(currencyList); // this transforms { key1: value1 } to [ [key1, value1] ] which we need to do to sort
        currencyList = _.orderBy(currencyList, '1'); // sorts by 2nd value in list

        this.setState({
            currencyList: [...newCurrencyList, FilterWithMapper.hr, ...currencyList]
        });
    }

    onChange(event) {
        if (this.props.onChange) {
            this.props.onChange(event);
        }

        if (!event || _.isEmpty(event)) {
            return;
        }

        const currencyId = event;

        let currencyHistory = localStorageUtil.getItem(currencyHistoryKey) || defaultCurrencyHistory;
        currencyHistory = _.filter(currencyHistory, (curr) => {
            return curr !== currencyId;
        });
        currencyHistory.unshift(currencyId);
        currencyHistory = _.slice(currencyHistory, 0, 5);

        localStorageUtil.setItem(currencyHistoryKey, currencyHistory);

        this.updateCurrencyList(currencyHistory);
    }

    render() {
        return (
            <FilterWithMapper onChange={this.onChange} filter={this.props.filter} mapper={this.state.currencyList}/>
        );
    }
}

export default SmartCurrencyCodeFilter;
